import { atom } from "recoil";

const workoutPlanAtom = atom({
  key: "workoutPlan",
  default: {
    workoutDay: {},
    warmUpExercises: [],
    strengthExercises: [],
    supersets: [],
    cardioExercises: [],
  },
});

export default workoutPlanAtom;
